// extracted by mini-css-extract-plugin
module.exports = {"text":"JdYkZv","image":"_1lq5JX","subTitle":"_35TOwU","shine-lines":"_1t6avC"};